(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollStopTimer = null;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.menuDetails = this.querySelector('header-drawer details');
      this.menuSummary = this.menuDetails ? this.menuDetails.querySelector('summary') : null;
      this.menuScrollTop = 0;
      // KOLEKA: Move to the page top BEFORE Shopify opens the drawer.
      // Capture-phase click works for mouse, touch and keyboard activation.
      this.captureMenuScroll = () => {
        if (this.menuDetails?.open) return; // Closing: don't jump.

        const root = document.documentElement;
        const oldBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        root.style.scrollBehavior = oldBehavior;
        this.menuScrollTop = 0;
      };
      this.handleMenuToggle = () => {
        if (!this.menuDetails) return;
        if (this.menuDetails.open) {
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
          const headerBottom = Math.max(0, Math.round(this.header.getBoundingClientRect().bottom));
          document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
        }

      };
      if (this.menuSummary) this.menuSummary.addEventListener('click', this.captureMenuScroll, true);
      if (this.menuDetails) this.menuDetails.addEventListener('toggle', this.handleMenuToggle);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.clearTimeout(this.scrollStopTimer);
      if (this.menuSummary) this.menuSummary.removeEventListener('click', this.captureMenuScroll, true);
      if (this.menuDetails) this.menuDetails.removeEventListener('toggle', this.handleMenuToggle);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      /* An open drawer/dropdown owns the screen; scrolling must not move its header. */
      if (this.querySelector('details[open]')) {
        requestAnimationFrame(this.reveal.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }
      window.clearTimeout(this.scrollStopTimer);
      this.scrollStopTimer = window.setTimeout(() => {
        if (!this.querySelector('details[open]') && window.scrollY > this.headerBounds.bottom) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      }, 260);
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.querySelector('details[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
